import React from 'react';

export default function BaseInput(props) {
  const id = props.id || 'input-' + props.name;
  //const label = props.label === null ? null : props.label || props.name;
  const value = (!props.value && props.value !== 0) ? '' : props.value;
  const onChange = function (e) {
    const newValue = e.target.value;
    if (props.onChange) props.onChange({name: props.name, value: newValue});
    else console.log(props.name, e.target.value);
  };
  let labelClassName = null;
  let inputDivClassName = null;
  if (props.horizontal) {
    labelClassName = "col-sm-2 control-label";
    inputDivClassName = "col-sm-10";
  }
  if (props.customAddonAfter) {
    inputDivClassName = "input-group";
  }
  let formGroupClassName = 'form-group';
  if (props.error) formGroupClassName += ' has-error';
  const inputProps = {
    type: props.inputType || 'text',
    className: 'form-control',
    id,
    name: props.name,
    value,
    placeholder: props.placeholder,
    onChange,
    disabled: props.disabled,
  };
  const label = props.label === null ? null
  : (<label htmlFor={id} className={labelClassName}>
    {props.label || props.name}
  </label>);
  const message = props.error || props.message;
  return (
    <div className={formGroupClassName}>
      {label}
      <div className={inputDivClassName}>
        <input {...inputProps}/>
        {
          props.customAddonAfter
            ? props.customAddonAfter
            : null
        }
      </div>
      <span className="help-block">{message}</span>
    </div>
  );
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Input.jsx